const INITIAL_STATE = {
  amountOwedByStudents: {
    error: null,
    calculating: false,
    data: null,
  },
};

const billingReducerNew = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'CALCULATE_AMOUNT_OWED_BY_STUDENTS_REQUESTED':
      return {
        ...state,
        amountOwedByStudents: {
          ...state.amountOwedByStudents,
          calculating: true,
          error: null,
        },
      };
    case 'CALCULATE_AMOUNT_OWED_BY_STUDENTS_SUCCEEDED':
      return {
        ...state,
        amountOwedByStudents: {
          ...state.amountOwedByStudents,
          calculating: false,
          data: action.payload,
        },
      };

    case 'CALCULATE_AMOUNT_OWED_BY_STUDENTS_FAILED':
      return {
        ...state,
        amountOwedByStudents: {
          ...state.amountOwedByStudents,
          calculating: false,
          error: action.payload,
        },
      };

    default:
      return state;
  }
};

export default billingReducerNew;
